import { Theme } from '@mui/material/styles'

export const getStyles = (theme: Theme) => ({
  header: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginTop: theme.spacing(4),
  },

  firstHeader: { marginTop: theme.spacing(1) },
})
